import React from "react";
import { nanoid } from "nanoid";
import TooltipWrapper from "@frameworks/NCD/Components/Tooltip/TooltipWrapper";
var Details = function (_a) {
    var details = _a.details;
    var uniqueIdForTooltipContainer = nanoid();
    return (React.createElement("div", { className: "bg-white px-3 py-4-custom box-shadow-light border-cylindrical-coordinate-bottom", id: uniqueIdForTooltipContainer },
        React.createElement("div", { className: "details-container gap-24" },
            React.createElement("h2", { className: "details-title DMSansNormal_20_400" },
                React.createElement("span", { className: "icon" },
                    React.createElement("i", { className: "edel-icon-aum-size d-flex align-items-center justify-content-between txt-vistaBlue fs-24" })),
                " ",
                "Details"),
            React.createElement("div", { className: "details-grid" }, details.map(function (item, index) { return (React.createElement("div", { key: index, className: "detail-item ms-2 flex items-center remove-btn-props" },
                React.createElement(TooltipWrapper, { content: item.label, containerId: uniqueIdForTooltipContainer },
                    React.createElement("div", { className: "".concat(item.labelClassName, " label DMsanL_12_300 cursor-pointer text-truncate") },
                        item.label || "-",
                        item.icon && React.createElement("span", { className: "mt-1" }, item.icon))),
                React.createElement(TooltipWrapper, { content: item.value, containerId: uniqueIdForTooltipContainer },
                    React.createElement("div", { className: "value ".concat(item.valueClassName, " text-truncate") }, item.value || "-")))); })))));
};
export default Details;
